/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestUniswapV2Router extends Contract<ITestUniswapV2Router> {
  getAmountsOut: Call<(_amountIn: BigNumberish, _path: AddressLike[]) => BigNumber[], ITestUniswapV2Router>
  'getAmountsOut(uint256,address[])': Call<(_amountIn: BigNumberish, _path: AddressLike[]) => BigNumber[], ITestUniswapV2Router>
  quote: Call<(_amountA: BigNumberish, _reserveA: BigNumberish, _reserveB: BigNumberish) => BigNumber, ITestUniswapV2Router>
  'quote(uint256,uint256,uint256)': Call<(_amountA: BigNumberish, _reserveA: BigNumberish, _reserveB: BigNumberish) => BigNumber, ITestUniswapV2Router>
  swapExactTokensForTokensSupportingFeeOnTransferTokens: Send<(_amountIn: BigNumberish, _amountOutMin: BigNumberish, _path: AddressLike[], _to: AddressLike, _deadline: BigNumberish) => void, ITestUniswapV2Router>
  'swapExactTokensForTokensSupportingFeeOnTransferTokens(uint256,uint256,address[],address,uint256)': Send<(_amountIn: BigNumberish, _amountOutMin: BigNumberish, _path: AddressLike[], _to: AddressLike, _deadline: BigNumberish) => void, ITestUniswapV2Router>
}

let ITestUniswapV2RouterBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestUniswapV2RouterBytecode = '0x';
}

// prettier-ignore
export const ITestUniswapV2Router = contract<ITestUniswapV2Router>(ITestUniswapV2RouterBytecode)`
  function getAmountsOut(uint256 _amountIn, address[] _path) view returns (uint256[] amounts_)
  function quote(uint256 _amountA, uint256 _reserveA, uint256 _reserveB) pure returns (uint256 quote_)
  function swapExactTokensForTokensSupportingFeeOnTransferTokens(uint256 _amountIn, uint256 _amountOutMin, address[] _path, address _to, uint256 _deadline)
`;